import React from 'react'

const Tabs = ({ tabs, activeTab, handleToggleTab }) => {
  let toggleClass = 'col-6 py-3 flex-grow-1 '
  let inactiveClass = 'text-muted'
  let activeClass = 'font-weight-bold text-brand'

  return (
    <div className="d-flex text-center border-bottom mb-3">
      {tabs &&
        tabs.map((tab, index) => (
          <div key={index}
            className={
              toggleClass + (activeTab === tab ? activeClass : inactiveClass)
            }
            style={
              activeTab === tab ? { borderBottom: '3px solid #466ea5' } : {}
            }
            onClick={() => handleToggleTab(tab)}
          >
            {tab}
          </div>
        ))}
    </div>
  )
}

export default Tabs
